export default __webpack_public_path__ + "static/media/DrukWM.2eca3f27.woff2";